import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: 'AIzaSyBOKl6etk0_T2JWadO-yNIF4f-NWew14rU',
  authDomain: 'vovtintuc.firebaseapp.com',
  projectId: 'vovtintuc',
  storageBucket: 'vovtintuc.appspot.com',
  messagingSenderId: '320638188069',
  appId: '1:320638188069:web:d866b8e6e1cdf3cb4c5dcc',
  measurementId: 'G-VX88NH0ZQB',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
const firebaseAuth = getAuth(app);

firebaseAuth.languageCode = 'vi';

export default firebaseAuth;
